var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9997 7.05V4C10.9997 3.73478 10.8943 3.48043 10.7068 3.29289C10.5193 3.10536 10.2649 3 9.9997 3C9.73736 3.0011 9.48597 3.10526 9.2997 3.29L2.2997 10.29C2.20598 10.383 2.13158 10.4936 2.08081 10.6154C2.03004 10.7373 2.00391 10.868 2.00391 11C2.00391 11.132 2.03004 11.2627 2.08081 11.3846C2.13158 11.5064 2.20598 11.617 2.2997 11.71L9.2997 18.71C9.44009 18.8476 9.61792 18.9408 9.81096 18.9779C10.004 19.015 10.2037 18.9944 10.3851 18.9186C10.5665 18.8429 10.7215 18.7153 10.8308 18.5519C10.9402 18.3886 10.9989 18.1966 10.9997 18V14.9H11.8497C13.4296 14.8764 14.9957 15.197 16.4394 15.8393C17.883 16.4817 19.1695 17.4306 20.2097 18.62C20.3351 18.7869 20.5095 18.9104 20.7085 18.9731C20.9076 19.0359 21.1213 19.0348 21.3197 18.97C21.5216 18.9019 21.6965 18.771 21.8188 18.5965C21.9411 18.422 22.0045 18.213 21.9997 18C21.9997 8.88 13.9197 7.32 10.9997 7.05ZM11.8497 12.88C11.1809 12.8779 10.5126 12.9213 9.8497 13.01C9.61296 13.0459 9.39697 13.1656 9.24099 13.3473C9.08501 13.5289 8.99939 13.7606 8.9997 14V15.59L4.4197 11L8.9997 6.41V8C8.9997 8.26522 9.10506 8.51957 9.2926 8.70711C9.48013 8.89464 9.73449 9 9.9997 9C10.9097 9 18.1097 9.2 19.6697 15.43C17.4054 13.7606 14.6629 12.8663 11.8497 12.88Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxShare);
export default __webpack_public_path__ + "static/media/bx-share.8a263011e2608ff98480ef56b09c6823.svg";
export { ForwardRef as ReactComponent };